
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("5bBud", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7c9473b70adca193$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $jG2Eu = parcelRequire("jG2Eu");

var $kFGm5 = parcelRequire("kFGm5");

var $gUUjF = parcelRequire("gUUjF");

var $bvJ6X = parcelRequire("bvJ6X");

var $ctR9z = parcelRequire("ctR9z");

var $3HCkE = parcelRequire("3HCkE");

var $ellXt = parcelRequire("ellXt");

var $grmb7 = parcelRequire("grmb7");
const $7c9473b70adca193$var$NewIssueCreateTrigger = ()=>{
    const { data: data } = (0, $3HCkE.useResource)((0, $ellXt.gicOptInStatusResources));
    const subscriptionHandle = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))));
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const currentIssueCreateVisibility = data?.gicOptInStatus;
    const openIssueCreateDialogHandler = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_payload' implicitly has an 'any' type.
    (event, _payload)=>{
        let payload;
        if (event instanceof CustomEvent && !_payload) payload = event.detail;
        else payload = _payload;
        const actualPayload = payload?.payload;
        const triggerPointKey = payload?.triggerPointKey;
        // EXAMPLE of payload not to be transformed
        // {
        //     shouldNotTransform: true,
        //     payload: {
        //         customFieldsToPreserveOnFormRecreation: ['issuelinks'],
        //         defaultValues: {
        //             issueLinks: {
        //                 linkedIssueKeys: ['IC-31'],
        //             },
        //         },
        //     },
        // },
        if (currentIssueCreateVisibility !== null) {
            if (currentIssueCreateVisibility?.isEnabled) {
                const extractedPayload = actualPayload?.target ? (0, $grmb7.extractEventAttributes)(actualPayload.target) : actualPayload;
                let createModalPayload = null;
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(extractedPayload)) {
                    if (payload?.shouldNotTransform === true) createModalPayload = extractedPayload;
                    else createModalPayload = (0, $grmb7.transformGICPayload)(extractedPayload);
                }
                // extract params
                openIssueCreateModal({
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(payload, [
                        'shouldNotTransform'
                    ]),
                    payload: createModalPayload,
                    triggerPointKey: triggerPointKey
                });
            } else (0, $bvJ6X.default)((0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(payload, [
                'shouldNotTransform'
            ]));
        } else (0, $gUUjF.default).safeErrorWithoutCustomerData('new-issue-create-trigger', 'visibility data is still getting downloaded');
    }, [
        currentIssueCreateVisibility,
        openIssueCreateModal
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (currentIssueCreateVisibility !== null) {
            window.IssueCreate = window.IssueCreate || {};
            window.IssueCreate.Visibility = currentIssueCreateVisibility; // For monolith to consume the same
        }
    }, [
        currentIssueCreateVisibility
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        document.addEventListener('openIssueCreateDialog', openIssueCreateDialogHandler);
        subscriptionHandle.current = ()=>// @ts-expect-error - TS2769 - No overload matches this call.
            document.removeEventListener('openIssueCreateDialog', openIssueCreateDialogHandler);
        return ()=>{
            subscriptionHandle.current();
            subscriptionHandle.current = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        };
    }, [
        openIssueCreateDialogHandler,
        subscriptionHandle
    ]);
    return null;
};
var $7c9473b70adca193$export$2e2bcd8739ae039 = $7c9473b70adca193$var$NewIssueCreateTrigger;

});
parcelRegister("bvJ6X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a8d85aebfa17569$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");

var $1ybV0 = parcelRequire("1ybV0");

var $1Ph9z = parcelRequire("1Ph9z");

var $8m3xX = parcelRequire("8m3xX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3a8d85aebfa17569$export$2e2bcd8739ae039 = ({ timeout: timeout, tentatives: tentatives, isInitialLoad: // isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
isInitialLoad, triggerSource: triggerSource, showModern: showModern } = {})=>{
    (0, $8m3xX.sendStartMarkForLegacyIssueCreate)({
        isInitialLoad: isInitialLoad,
        triggerSource: triggerSource
    });
    (0, $1Ph9z.initForgeBridge)();
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $2BvS3.loadBridge)({
        name: 'quick-edit/init/create-dialogs',
        wrmKeys: [
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs'
        ],
        timeout: timeout,
        tentatives: tentatives
    }).then((api)=>{
        if ((0, $1ybV0.ff)('project.config.pce.modern.global-issue-create.trigger')) {
            if (showModern === true) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.hideLoadingIndicator(false);
            else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.showCreateDialog({
                showModern: showModern
            });
        } else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        api.showCreateDialog({});
        (0, $8m3xX.sendEndMarkForLegacyIssueCreate)({
            isInitialLoad: isInitialLoad
        });
    });
};

});
parcelRegister("1Ph9z", function(module, exports) {

$parcel$export(module.exports, "initForgeBridge", () => $0c9c0b19b2b0ff3b$export$8e110dda7ad69e5a);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");

var $e91YZ = parcelRequire("e91YZ");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $arKaN = parcelRequire("arKaN");

var $2jpBk = parcelRequire("2jpBk");
const $0c9c0b19b2b0ff3b$var$loadModules = async (dataClassification = null)=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const modulesToFetch = [
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE),
        (0, $2Rqjr.WORKFLOW_CONDITION_MODULE),
        (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE)
    ];
    const contextIds = (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x') ? [
        `ari:cloud:jira:${cloudId}:workspace/${activationId}`
    ] : undefined;
    const { extensions: extensions } = await (0, $arKaN.default)(cloudId, modulesToFetch, dataClassification, undefined, (0, $2Rqjr.SOURCE_LEGACY), contextIds);
    const customFields = extensions.jiraCustomField;
    const customFieldTypes = extensions.jiraCustomFieldType;
    const workflowValidators = extensions.jiraWorkflowValidator;
    const workflowConditions = extensions.jiraWorkflowCondition || [];
    const workflowPostFunctions = extensions.jiraWorkflowPostFunction || [];
    return {
        customFields: customFields,
        customFieldTypes: customFieldTypes,
        workflowValidators: workflowValidators,
        workflowConditions: workflowConditions,
        workflowPostFunctions: workflowPostFunctions
    };
};
const $0c9c0b19b2b0ff3b$export$8e110dda7ad69e5a = async ()=>{
    const components = {
        customField: $2jpBk.customField,
        workflowValidator: $2jpBk.workflowValidator,
        workflowCondition: $2jpBk.workflowCondition,
        workflowPostFunction: $2jpBk.workflowPostFunction
    };
    /* eslint-disable jira/wrm/no-load-bridge */ const [modules, bridge] = await Promise.all([
        $0c9c0b19b2b0ff3b$var$loadModules(),
        (0, $2BvS3.loadBridge)({
            name: 'jira/forge/bridge',
            wrmKeys: 'wrc!com.atlassian.jira.jira-atlaskit-plugin:forge-bridge'
        }).catch((e)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('forge.legacy.bridge', 'Cannot load the bridge', e);
            return e;
        })
    ]);
    // modules contains all modules data
    // components contains modules to render
    // loadModules method can be invoked with data classification to get the filtered modules by access narrowing
    /* eslint-enable jira/wrm/no-load-bridge */ const API = {
        modules: modules,
        components: components,
        loadModules: $0c9c0b19b2b0ff3b$var$loadModules
    };
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    bridge(API);
};

});
parcelRegister("2jpBk", function(module, exports) {

$parcel$export(module.exports, "customField", () => $862ab2c37c653be2$export$82c8c2cee582a640);
$parcel$export(module.exports, "workflowCondition", () => $862ab2c37c653be2$export$8fe15afd9a3cb1e7);
$parcel$export(module.exports, "workflowPostFunction", () => $862ab2c37c653be2$export$f7a58b73e10db093);
$parcel$export(module.exports, "workflowValidator", () => $862ab2c37c653be2$export$75e1428e5ba72a);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $49235 = parcelRequire("49235");

var $hYKgv = parcelRequire("hYKgv");

var $gG6DD = parcelRequire("gG6DD");

var $gAaaZ = parcelRequire("gAaaZ");

var $31gDV = parcelRequire("31gDV");
const $862ab2c37c653be2$export$82c8c2cee582a640 = {
    renderView: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYKgv.CustomField), props), container);
        return container;
    },
    renderEditView: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYKgv.CustomFieldEdit), props), container);
        return container;
    }
};
const $862ab2c37c653be2$export$8fe15afd9a3cb1e7 = {
    renderView: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gG6DD.WorkflowConditionView), props)), container);
        return container;
    },
    renderCreate: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gG6DD.WorkflowConditionCreate), props)), container);
        return container;
    },
    renderEdit: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gG6DD.WorkflowConditionEdit), props)), container);
        return container;
    }
};
const $862ab2c37c653be2$export$f7a58b73e10db093 = {
    renderView: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAaaZ.WorkflowPostFunctionView), props)), container);
        return container;
    },
    renderCreate: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAaaZ.WorkflowPostFunctionCreate), props)), container);
        return container;
    },
    renderEdit: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAaaZ.WorkflowPostFunctionEdit), props)), container);
        return container;
    }
};
const $862ab2c37c653be2$export$75e1428e5ba72a = {
    renderView: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31gDV.WorkflowValidatorView), props)), container);
        return container;
    },
    renderCreate: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31gDV.WorkflowValidatorCreate), props)), container);
        return container;
    },
    renderEdit: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31gDV.WorkflowValidatorEdit), props)), container);
        return container;
    }
};

});
parcelRegister("hYKgv", function(module, exports) {

$parcel$export(module.exports, "CustomField", () => $c7576677d58b0b16$export$9639a5943929d469);
$parcel$export(module.exports, "CustomFieldEdit", () => $c7576677d58b0b16$export$5de2ecfed36387cf);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $5syGA = parcelRequire("5syGA");

var $elbiT = parcelRequire("elbiT");

var $3zABe = parcelRequire("3zABe");

var $fe3vy = parcelRequire("fe3vy");
const $c7576677d58b0b16$export$9639a5943929d469 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elbiT.ViewAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fe3vy.AsyncCustomField), props));
const $c7576677d58b0b16$var$CustomFieldEditView = (props)=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(true);
    const { onCancel: onCancel, onSave: onSave } = props;
    const onCancelCallback = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
        onCancel && onCancel();
    }, [
        onCancel
    ]);
    const onSaveCallback = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        setIsOpen(false);
        return onSave(e);
    }, [
        onSave
    ]);
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3zABe.AsyncCustomFieldEdit), {
        ...props,
        onCancel: onCancelCallback,
        onSave: onSaveCallback
    }) : null;
};
const $c7576677d58b0b16$export$5de2ecfed36387cf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elbiT.EditAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7576677d58b0b16$var$CustomFieldEditView, props));

});
parcelRegister("5syGA", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $05fce0f798595dcf$export$5d3b06ab08af139e);

var $2vJHJ = parcelRequire("2vJHJ");

var $70ON1 = parcelRequire("70ON1");
const $05fce0f798595dcf$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});
parcelRegister("2vJHJ", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $0071fffa92d48f40$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $0071fffa92d48f40$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $0071fffa92d48f40$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $0071fffa92d48f40$export$42b85bc9b386c977);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");
const $0071fffa92d48f40$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    if (!(0, $1ybV0.ff)('fix-forge-ui-type-detection_nmgpj')) {
        if (render != null && render !== 'native') return 'ui-kit';
    }
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
        extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $0071fffa92d48f40$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $0071fffa92d48f40$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $0071fffa92d48f40$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(propsToOverride)) return extension;
    const { resource: resource, requiresUserConsent: requiresUserConsent } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        },
        requiresUserConsent: requiresUserConsent
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});


parcelRegister("elbiT", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $4ecd31271e5beb2f$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $4ecd31271e5beb2f$export$947ae3996b2bc000);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $4ecd31271e5beb2f$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $4ecd31271e5beb2f$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
        ...props
    });

});
parcelRegister("1boRu", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $e499aee6653ef75f$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $e499aee6653ef75f$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $e499aee6653ef75f$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $e499aee6653ef75f$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $e499aee6653ef75f$export$14e56d7f5d3f917c);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $9x02J = parcelRequire("9x02J");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $2qZHF = parcelRequire("2qZHF");

var $hRcYT = parcelRequire("hRcYT");

var $8XU7c = parcelRequire("8XU7c");

var $bBGpO = parcelRequire("bBGpO");

var $9Z5wa = parcelRequire("9Z5wa");

var $5syGA = parcelRequire("5syGA");

var $d6g7g = parcelRequire("d6g7g");
const $e499aee6653ef75f$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: (0, $bBGpO.createAttributes)(attributes)
    });
const $e499aee6653ef75f$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $9Z5wa.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $e499aee6653ef75f$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $9x02J.useHasForgeAccess)();
    const analyticsAttributes = (0, $bBGpO.createAttributes)({
        ...attributes,
        hasForgeAccess: hasForgeAccess
    });
    const fireEvent = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, (0, $8XU7c.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: fireEvent
    });
};
const $e499aee6653ef75f$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $e499aee6653ef75f$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $eUqFw.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $eUqFw.useCallback)((error)=>(0, $bBGpO.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hRcYT.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $e499aee6653ef75f$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $8XU7c.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>(0, $bBGpO.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $2Rqjr.CUSTOM_FIELD_MODULE) || extensionModule === (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $2Rqjr.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $2Rqjr.GLOBAL_PAGE_MODULE),
        (0, $2Rqjr.ISSUE_ACTION_MODULE),
        (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        (0, $2Rqjr.ISSUE_PANEL_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.PROJECT_PAGE_MODULE),
        (0, $2Rqjr.ADMIN_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $e499aee6653ef75f$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const isCustomUI = (0, $2vJHJ.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $eUqFw.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $8XU7c.getEventId)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $8XU7c.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $eUqFw.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $5syGA.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        !$e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId && (0, $d6g7g.forgeModulesLoadTime).start({
            startTime: performance.now()
        });
        const onError = (0, $eUqFw.useCallback)(()=>{
            extensionId && (0, $d6g7g.forgeModulesLoadTime).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $eUqFw.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $d6g7g.forgeModulesLoadTime).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $9Z5wa.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $eUqFw.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $d6g7g.forgeModulesLoadTime).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("9x02J", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2);

var $6yplV = parcelRequire("6yplV");
const $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("2qZHF", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $017cfdc2fc017c3b$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
// eslint-disable-next-line jira/react/no-class-components
class $017cfdc2fc017c3b$var$MountEventComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $017cfdc2fc017c3b$export$2c6963927dbc68f1 = (0, $2jDha.default)()($017cfdc2fc017c3b$var$MountEventComponent);

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("8XU7c", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $ea56d020133ed4ec$export$5639f6a927500d9);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $ea56d020133ed4ec$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getEventActionName", () => $ea56d020133ed4ec$export$644ccb9a67b9a9c1);

var $2Rqjr = parcelRequire("2Rqjr");

var $TrUS5 = parcelRequire("TrUS5");

var $hRcYT = parcelRequire("hRcYT");


var $eTZsp = parcelRequire("eTZsp");

var $d6g7g = parcelRequire("d6g7g");
const $ea56d020133ed4ec$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $ea56d020133ed4ec$var$prepareModuleMode = (entryPoint)=>`${$ea56d020133ed4ec$var$capitalizeFirstLetter(entryPoint)}`;
const $ea56d020133ed4ec$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $ea56d020133ed4ec$var$prepareModuleName = (moduleName)=>(0, $2Rqjr.SUPPORTED_MODULES).includes(moduleName) ? $ea56d020133ed4ec$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $ea56d020133ed4ec$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $ea56d020133ed4ec$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
const $ea56d020133ed4ec$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hRcYT.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});

parcelRegister("9Z5wa", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $2660eb080e6928fb$export$add44f896fb31ba3);

var $hRcYT = parcelRequire("hRcYT");

var $cYWDh = parcelRequire("cYWDh");
const $2660eb080e6928fb$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});



parcelRegister("3zABe", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomFieldEdit", () => $c7a0c627b293f096$export$61f4a77d813bf4b4);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $d6g7g = parcelRequire("d6g7g");
var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");

var $2Rqjr = parcelRequire("2Rqjr");

var $gamHX = parcelRequire("gamHX");

var $2vJHJ = parcelRequire("2vJHJ");

var $k9lIU = parcelRequire("k9lIU");

var $gGtKh = parcelRequire("gGtKh");

var $gWRle = parcelRequire("gWRle");
const $c7a0c627b293f096$export$fc8c2ed652969e74 = (fieldValue, onSave, onConfirm, showFlag)=>onSave(fieldValue).then((response)=>{
        if (response == null) return;
        // The error is handled in the catch block
        if ('error' in response) {
            if (response.error) throw response.error;
        } else onConfirm(response.data);
    }).catch((error)=>{
        showFlag((0, $k9lIU.default)(error));
        // Custom UI depends on this error to get know whether the form was successfully submitted or not
        if ((0, $7byHA.isValidationError)(error)) throw error;
        throw Error(`Unable to save custom field, error: ${error.message}`);
    });

const $c7a0c627b293f096$var$getModule = ()=>(0, $d6g7g.measureInitialPageLoadAsyncResourcesTiming)((0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START, (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END, ()=>(parcelRequire("2B5zn")));
const $c7a0c627b293f096$export$55429035358dd625 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$c7a0c627b293f096$var$getModule().then((module)=>module.CustomFieldEdit), {
    ssr: false
}));
const $c7a0c627b293f096$export$5ffe94eb10d5f1f4 = ({ onSave: onSave, onCancel: onCancel, onConfirm: onConfirm, onError: onError, onRender: onRender, ...restProps })=>{
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const extensionDataValue = (0, $eUqFw.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldType: extensionData.fieldType,
            fieldId: extensionData.fieldId,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
        };
    }, [
        extension.type,
        extensionData
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>({
            module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload
    ]);
    const submit = (0, $eUqFw.useCallback)(({ data: fieldValue })=>$c7a0c627b293f096$export$fc8c2ed652969e74(fieldValue, onSave, onConfirm, showFlag), // todo SMT-491 onConfirm, onSave (fieldId) was changing every time component tree was changed by Bento issue view.
    // root cause - Bento's connect-field is creating onConfirm function and fieldId every time. More in mentioned ticket
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        showFlag
    ]);
    const close = onCancel;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const bridge = (0, $eUqFw.useMemo)(()=>({
            submit: submit,
            close: close
        }), [
        submit,
        close
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWRle.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-field-edit",
        fallback: null
    }, (0, $2vJHJ.isCustomUIExtension)(extension, (0, $2Rqjr.ENTRY_POINT_EDIT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gamHX.LazyModalIframe), {
        ...restProps,
        ...extraProps,
        bridge: bridge,
        onClose: onCancel,
        onLoad: onRender
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7a0c627b293f096$export$55429035358dd625, {
        ...restProps,
        ...extraProps,
        onError: onError,
        onRender: onRender,
        onCancel: onCancel,
        submit: submit,
        bridge: bridge
    })));
};
const $c7a0c627b293f096$export$61f4a77d813bf4b4 = $c7a0c627b293f096$export$5ffe94eb10d5f1f4;

});
parcelRegister("gamHX", function(module, exports) {

$parcel$export(module.exports, "LazyIframe", () => $06c11067a462069c$export$808646051d5a3908);
$parcel$export(module.exports, "LazyModalIframe", () => $06c11067a462069c$export$f35ac420e260eb7);

var $7rh0R = parcelRequire("7rh0R");

var $1boRu = parcelRequire("1boRu");

const $06c11067a462069c$var$getModule = ()=>(parcelRequire("k9s7y"));
const $06c11067a462069c$export$808646051d5a3908 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$06c11067a462069c$var$getModule().then((module)=>module.IframeRenderer), {
    ssr: false
}));
const $06c11067a462069c$export$f35ac420e260eb7 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazy)(()=>$06c11067a462069c$var$getModule().then((module)=>module.ModalIframeRenderer), {}));

});
parcelRegister("k9s7y", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('8ficv')
        ]);
        const value = parcelRequire('kq5KC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("8ficv")
    ]).then(()=>parcelRequire('kq5KC'));
}

});


parcelRegister("k9lIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38e26aef80874b3$export$2e2bcd8739ae039);

var $7byHA = parcelRequire("7byHA");

var $e4byB = parcelRequire("e4byB");

var $gYPHE = parcelRequire("gYPHE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a38e26aef80874b3$export$2e2bcd8739ae039 = (error)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $7byHA.isValidationError)(error) ? (0, $gYPHE.default)(error.errors) : (0, $e4byB.default)();

});
parcelRegister("e4byB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b05c03b9263b7a0c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $b05c03b9263b7a0c$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.generic-error.title",
        "defaultMessage": "We were unable to edit this custom field. Please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b05c03b9263b7a0c$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $b05c03b9263b7a0c$var$messages.title,
        isAutoDismiss: false
    });

});

parcelRegister("gYPHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbc09c79bc08bf01$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $dbc09c79bc08bf01$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.validation-error.title",
        "defaultMessage": "Validation error"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dbc09c79bc08bf01$export$2e2bcd8739ae039 = (errors)=>({
        type: 'error',
        title: $dbc09c79bc08bf01$var$messages.title,
        description: errors.map(({ error: error })=>error).join(', '),
        isAutoDismiss: false
    });

});


parcelRegister("gWRle", function(module, exports) {

$parcel$export(module.exports, "StopSubmitPropagation", () => $1ee7d0bd2c357478$export$238f56c0891e9254);

var $eUqFw = parcelRequire("eUqFw");
const $1ee7d0bd2c357478$export$e6dfd72ab29f8598 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper",
        onSubmit: props.onSubmit
    }, props.children);
const $1ee7d0bd2c357478$export$238f56c0891e9254 = ({ children: children })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ee7d0bd2c357478$export$e6dfd72ab29f8598, {
        onSubmit: handleSubmit
    }, children);
};

});

parcelRegister("2B5zn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('bf9ps'),
            load('kWrFZ'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('2Lfdl'),
            load('h2MrD'),
            load('bYT2S'),
            load('7pzTP')
        ]);
        const value = parcelRequire('hd1cG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("bf9ps"),
        load("kWrFZ"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("2Lfdl"),
        load("h2MrD"),
        load("bYT2S"),
        load("7pzTP")
    ]).then(()=>parcelRequire('hd1cG'));
}

});


parcelRegister("fe3vy", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomField", () => $553f56b38256a231$export$3d94b128d17ce776);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $d6g7g = parcelRequire("d6g7g");
var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");

var $2Rqjr = parcelRequire("2Rqjr");

var $gGtKh = parcelRequire("gGtKh");

var $8Nthx = parcelRequire("8Nthx");

const $553f56b38256a231$var$getModule = ()=>(0, $d6g7g.measureInitialPageLoadAsyncResourcesTiming)((0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START, (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END, ()=>(parcelRequire("bJzyX")));
const $553f56b38256a231$var$skeletonConfig = [
    {
        width: 100
    }
];
const $553f56b38256a231$export$2a6d819caf09da30 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$553f56b38256a231$var$getModule().then((module)=>module.CustomField), {
    ssr: false
}));
const $553f56b38256a231$export$ffc72ef953e96226 = (props)=>{
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = props;
    const loadingComponent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
            skeletonConfig: $553f56b38256a231$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $eUqFw.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldType: extensionData.fieldType,
            fieldId: extensionData.fieldId,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext
        };
        return {
            ...preparedExtensionData,
            type: extension.type
        };
    }, [
        extension.type,
        extensionData
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-field-renderer",
        fallback: loadingComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($553f56b38256a231$export$2a6d819caf09da30, {
        ...props,
        ...extraProps
    }));
};
const $553f56b38256a231$export$3d94b128d17ce776 = $553f56b38256a231$export$ffc72ef953e96226;

});
parcelRegister("8Nthx", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $fb59735ddb4a6800$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonLayout", () => $fb59735ddb4a6800$export$af3ba02ef74c9bdf);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $fb59735ddb4a6800$export$69f3c7f0b2b87aa2 = [];
const $fb59735ddb4a6800$export$8f31e4c4a37b8e9c = ({ skeletonConfig: skeletonConfig = $fb59735ddb4a6800$export$69f3c7f0b2b87aa2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, skeletonConfig.map(({ width: width }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb59735ddb4a6800$var$ForgeSkeleton, {
            "data-testId": `forgeskeleton-${index}`,
            key: index,
            width: width
        })));
const $fb59735ddb4a6800$export$af3ba02ef74c9bdf = ({ children: children, layout: layout })=>{
    if (!layout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "forge-ui-async.common.ui.skeleton.box",
        xcss: $fb59735ddb4a6800$var$layoutStyles
    }, children);
};
const $fb59735ddb4a6800$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fb59735ddb4a6800$var$ForgeSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1y04s53": (0, $9t7rW.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mcm _4t3ipxbi _19pkpxbi _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk",
            __cmplp.className
        ])
    });
});
const $fb59735ddb4a6800$var$layoutStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});

});

parcelRegister("bJzyX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('bf9ps'),
            load('kWrFZ'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('2Lfdl'),
            load('h2MrD'),
            load('bYT2S'),
            load('auozo')
        ]);
        const value = parcelRequire('j34Xs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("bf9ps"),
        load("kWrFZ"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("2Lfdl"),
        load("h2MrD"),
        load("bYT2S"),
        load("auozo")
    ]).then(()=>parcelRequire('j34Xs'));
}

});



parcelRegister("gG6DD", function(module, exports) {

$parcel$export(module.exports, "WorkflowConditionCreate", () => $8e25faacecab1b95$export$7c5d91d150cf4af1);
$parcel$export(module.exports, "WorkflowConditionEdit", () => $8e25faacecab1b95$export$be9207c31b4d0498);
$parcel$export(module.exports, "WorkflowConditionView", () => $8e25faacecab1b95$export$2dda4bec0d23d56e);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $5syGA = parcelRequire("5syGA");

var $e7yHI = parcelRequire("e7yHI");

var $1qYPC = parcelRequire("1qYPC");
const $8e25faacecab1b95$export$7c5d91d150cf4af1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7yHI.CreateAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1qYPC.AsyncWorkflowConditionCreateEdit), {
        ...props,
        entryPoint: "create"
    }));
const $8e25faacecab1b95$export$be9207c31b4d0498 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7yHI.EditAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1qYPC.AsyncWorkflowConditionCreateEdit), {
        ...props,
        entryPoint: "edit"
    }));
const $8e25faacecab1b95$export$2dda4bec0d23d56e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7yHI.ViewAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1qYPC.AsyncWorkflowConditionView), {
        ...props,
        entryPoint: "view"
    }));

});
parcelRegister("e7yHI", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $e2df79b3ee094df3$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $e2df79b3ee094df3$export$947ae3996b2bc000);
$parcel$export(module.exports, "CreateAnalyticsWrapper", () => $e2df79b3ee094df3$export$92d71027daa95c83);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $e2df79b3ee094df3$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_CONDITION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_VIEW),
        ...props
    });
const $e2df79b3ee094df3$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_CONDITION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
        ...props
    });
const $e2df79b3ee094df3$export$92d71027daa95c83 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_CONDITION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_CREATE),
        ...props
    });

});

parcelRegister("1qYPC", function(module, exports) {

$parcel$export(module.exports, "AsyncWorkflowConditionCreateEdit", () => $68dd1043a4c856ca$export$6006938a750a95cf);
$parcel$export(module.exports, "AsyncWorkflowConditionView", () => $68dd1043a4c856ca$export$f52818748d92f596);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $eyvXg = parcelRequire("eyvXg");
const $68dd1043a4c856ca$export$f05650047f36f873 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowCreateEdit), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_CONDITION_MODULE)
    });
const $68dd1043a4c856ca$export$d15747c9ea39b63 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowView), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_CONDITION_MODULE)
    });
const $68dd1043a4c856ca$export$6006938a750a95cf = $68dd1043a4c856ca$export$f05650047f36f873;
const $68dd1043a4c856ca$export$f52818748d92f596 = $68dd1043a4c856ca$export$d15747c9ea39b63;

});
parcelRegister("eyvXg", function(module, exports) {

$parcel$export(module.exports, "LazyWorkflowView", () => $107d0cd08592bd4f$export$6d3477ca54d81ef7);
$parcel$export(module.exports, "LazyWorkflowCreateEdit", () => $107d0cd08592bd4f$export$b714d2a79a4b7082);

var $eUqFw = parcelRequire("eUqFw");

var $gamHX = parcelRequire("gamHX");

var $2vJHJ = parcelRequire("2vJHJ");

var $gGtKh = parcelRequire("gGtKh");

var $8Nthx = parcelRequire("8Nthx");
const $107d0cd08592bd4f$var$skeletonConfig = [
    {
        width: 100
    },
    {
        width: 75
    }
];
const $107d0cd08592bd4f$export$6d3477ca54d81ef7 = (props)=>{
    const { entryPoint: entryPoint, extension: extension, extensionData: extensionData, module: module, ...restProps } = props;
    const loadingComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
        skeletonConfig: $107d0cd08592bd4f$var$skeletonConfig
    });
    const extraProps = {
        entryPoint: entryPoint,
        extension: extension,
        loadingComponent: loadingComponent,
        module: module,
        extensionData: {
            ...extensionData,
            type: module,
            entryPoint: entryPoint
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "workflow-view",
        fallback: loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension, entryPoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gamHX.LazyIframe), {
        ...restProps,
        ...extraProps
    }));
};
const $107d0cd08592bd4f$export$b714d2a79a4b7082 = (props)=>{
    const { entryPoint: entryPoint, extension: extension, extensionData: extensionData, module: module, onSetConfigurationCallback: onSetConfigurationCallback, ...restProps } = props;
    const loadingComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
        skeletonConfig: $107d0cd08592bd4f$var$skeletonConfig
    });
    const extraProps = {
        entryPoint: entryPoint,
        extension: extension,
        loadingComponent: loadingComponent,
        module: module,
        extensionData: {
            ...extensionData,
            type: module,
            entryPoint: entryPoint
        }
    };
    const setWorkflowRuleConfigurationCallback = (0, $eUqFw.useCallback)((param)=>{
        if (!onSetConfigurationCallback) return;
        const { onConfigure: onConfigure } = param?.data || {};
        const callbackType = typeof onConfigure;
        if (callbackType !== 'function') throw new Error('Invalid "onConfigure" callback - function expected');
        onSetConfigurationCallback(async ()=>{
            const config = await onConfigure();
            return config;
        });
    }, [
        onSetConfigurationCallback
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customBridgeMethods = (0, $eUqFw.useMemo)(()=>({
            setWorkflowRuleConfigurationCallback: setWorkflowRuleConfigurationCallback
        }), [
        setWorkflowRuleConfigurationCallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "workflow-create-edit",
        fallback: loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension, entryPoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gamHX.LazyIframe), {
        ...restProps,
        ...extraProps,
        customBridgeMethods: customBridgeMethods
    }));
};

});



parcelRegister("gAaaZ", function(module, exports) {

$parcel$export(module.exports, "WorkflowPostFunctionCreate", () => $57840d66a281508b$export$9c721b17de78c59f);
$parcel$export(module.exports, "WorkflowPostFunctionEdit", () => $57840d66a281508b$export$45d016d27d63575f);
$parcel$export(module.exports, "WorkflowPostFunctionView", () => $57840d66a281508b$export$d9daa48ae954d3b8);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $5syGA = parcelRequire("5syGA");

var $1ApHa = parcelRequire("1ApHa");

var $eA1dC = parcelRequire("eA1dC");
const $57840d66a281508b$export$9c721b17de78c59f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ApHa.CreateAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eA1dC.AsyncWorkflowPostFunctionCreateEdit), {
        ...props,
        entryPoint: "create"
    }));
const $57840d66a281508b$export$45d016d27d63575f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ApHa.EditAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eA1dC.AsyncWorkflowPostFunctionCreateEdit), {
        ...props,
        entryPoint: "edit"
    }));
const $57840d66a281508b$export$d9daa48ae954d3b8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ApHa.ViewAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eA1dC.AsyncWorkflowPostFunctionView), {
        ...props,
        entryPoint: "view"
    }));

});
parcelRegister("1ApHa", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $fc439fd6fb003a44$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $fc439fd6fb003a44$export$947ae3996b2bc000);
$parcel$export(module.exports, "CreateAnalyticsWrapper", () => $fc439fd6fb003a44$export$92d71027daa95c83);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $fc439fd6fb003a44$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_VIEW),
        ...props
    });
const $fc439fd6fb003a44$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
        ...props
    });
const $fc439fd6fb003a44$export$92d71027daa95c83 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_CREATE),
        ...props
    });

});

parcelRegister("eA1dC", function(module, exports) {

$parcel$export(module.exports, "AsyncWorkflowPostFunctionCreateEdit", () => $c967688d5042f915$export$cfa61e5559ea0dce);
$parcel$export(module.exports, "AsyncWorkflowPostFunctionView", () => $c967688d5042f915$export$87ba64d38cfeb16a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $eyvXg = parcelRequire("eyvXg");
const $c967688d5042f915$export$86604dfb04526e1a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowCreateEdit), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE)
    });
const $c967688d5042f915$export$db5b75fe29c72654 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowView), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE)
    });
const $c967688d5042f915$export$cfa61e5559ea0dce = $c967688d5042f915$export$86604dfb04526e1a;
const $c967688d5042f915$export$87ba64d38cfeb16a = $c967688d5042f915$export$db5b75fe29c72654;

});


parcelRegister("31gDV", function(module, exports) {

$parcel$export(module.exports, "WorkflowValidatorCreate", () => $84ab2903f04f3ca0$export$b131ee6ae33375f7);
$parcel$export(module.exports, "WorkflowValidatorEdit", () => $84ab2903f04f3ca0$export$295e28146293a786);
$parcel$export(module.exports, "WorkflowValidatorView", () => $84ab2903f04f3ca0$export$8a0a1dfbf1819d74);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $5syGA = parcelRequire("5syGA");

var $bfPrz = parcelRequire("bfPrz");

var $dU2pm = parcelRequire("dU2pm");
const $84ab2903f04f3ca0$export$b131ee6ae33375f7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfPrz.CreateAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dU2pm.AsyncWorkflowValidatorCreateEdit), {
        ...props,
        entryPoint: "create"
    }));
const $84ab2903f04f3ca0$export$295e28146293a786 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfPrz.EditAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dU2pm.AsyncWorkflowValidatorCreateEdit), {
        ...props,
        entryPoint: "edit"
    }));
const $84ab2903f04f3ca0$export$8a0a1dfbf1819d74 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfPrz.ViewAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dU2pm.AsyncWorkflowValidatorView), {
        ...props,
        entryPoint: "view"
    }));

});
parcelRegister("bfPrz", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $76d2ae7b878c8c9b$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $76d2ae7b878c8c9b$export$947ae3996b2bc000);
$parcel$export(module.exports, "CreateAnalyticsWrapper", () => $76d2ae7b878c8c9b$export$92d71027daa95c83);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $76d2ae7b878c8c9b$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_VIEW),
        ...props
    });
const $76d2ae7b878c8c9b$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
        ...props
    });
const $76d2ae7b878c8c9b$export$92d71027daa95c83 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_CREATE),
        ...props
    });

});

parcelRegister("dU2pm", function(module, exports) {

$parcel$export(module.exports, "AsyncWorkflowValidatorCreateEdit", () => $fca447d3566778cb$export$54de7ff67b273896);
$parcel$export(module.exports, "AsyncWorkflowValidatorView", () => $fca447d3566778cb$export$9b5553aeb9e69415);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $eyvXg = parcelRequire("eyvXg");
const $fca447d3566778cb$export$b86c3ac240c092a8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowCreateEdit), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE)
    });
const $fca447d3566778cb$export$7547b0d39a9ad099 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowView), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE)
    });
const $fca447d3566778cb$export$54de7ff67b273896 = $fca447d3566778cb$export$b86c3ac240c092a8;
const $fca447d3566778cb$export$9b5553aeb9e69415 = $fca447d3566778cb$export$7547b0d39a9ad099;

});




parcelRegister("8m3xX", function(module, exports) {

$parcel$export(module.exports, "sendStartMarkForLegacyIssueCreate", () => $4157e2b9a99a5048$export$7dbcbf47a4e0e00f);
$parcel$export(module.exports, "sendEndMarkForLegacyIssueCreate", () => $4157e2b9a99a5048$export$b5c5d408bb7fd104);

var $7pmxV = parcelRequire("7pmxV");

var $iLDke = parcelRequire("iLDke");
const $4157e2b9a99a5048$export$7dbcbf47a4e0e00f = ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
        if (isInitialLoad) (0, $iLDke.legacyIssueCreateInitialRenderInteraction).start();
        else (0, $iLDke.legacyIssueCreateTransitionInteraction).start();
        (0, $iLDke.legacyIssueCreateCombinedInteraction).start();
    }
};
const $4157e2b9a99a5048$export$b5c5d408bb7fd104 = async ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    const Events = await (0, $7pmxV.apiReady)();
    const onCreateIssueDialogRendered = ()=>{
        if (typeof isInitialLoad === 'boolean') {
            if (isInitialLoad) (0, $iLDke.legacyIssueCreateInitialRenderInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            else (0, $iLDke.legacyIssueCreateTransitionInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            (0, $iLDke.legacyIssueCreateCombinedInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
        }
        Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
    };
    Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};

});
parcelRegister("7pmxV", function(module, exports) {

$parcel$export(module.exports, "apiReady", () => $255e282260d8623a$export$330fb1a04c974aad);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
let $255e282260d8623a$var$currentBridge;
const $255e282260d8623a$export$330fb1a04c974aad = async ()=>{
    if ($255e282260d8623a$var$currentBridge) return $255e282260d8623a$var$currentBridge;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/wrm/no-load-bridge
    const Events = await (0, $2BvS3.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $255e282260d8623a$var$currentBridge = Events;
    return Events;
};

});

parcelRegister("iLDke", function(module, exports) {

$parcel$export(module.exports, "legacyIssueCreateInitialRenderInteraction", () => $c60cfd887c71503f$export$2bc24132dfd54487);
$parcel$export(module.exports, "legacyIssueCreateTransitionInteraction", () => $c60cfd887c71503f$export$ba0054dee3105c90);
$parcel$export(module.exports, "legacyIssueCreateCombinedInteraction", () => $c60cfd887c71503f$export$52353a8848646ccd);

var $lEpcX = parcelRequire("lEpcX");
const $c60cfd887c71503f$export$2bc24132dfd54487 = (0, $lEpcX.metrics).interaction({
    key: 'legacy-issue-create.initial-render'
});
const $c60cfd887c71503f$export$ba0054dee3105c90 = (0, $lEpcX.metrics).interaction({
    key: 'legacy-issue-create.transition'
});
const $c60cfd887c71503f$export$52353a8848646ccd = (0, $lEpcX.metrics).interaction({
    key: 'legacy-issue-create.combined'
});

});



parcelRegister("grmb7", function(module, exports) {

$parcel$export(module.exports, "generateDefaultValues", () => $ac2928cb7824ba77$export$300f392f5922240);
$parcel$export(module.exports, "extractEventAttributes", () => $ac2928cb7824ba77$export$1e69307ca1d0a0a);
$parcel$export(module.exports, "transformGICPayload", () => $ac2928cb7824ba77$export$db3a4d24608ba186);

var $8blac = parcelRequire("8blac");

var $k4nIh = parcelRequire("k4nIh");

var $1ybV0 = parcelRequire("1ybV0");

var $cOaQi = parcelRequire("cOaQi");
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $ac2928cb7824ba77$var$mergePrefilled = (oldPayload, newPayload)=>{
    if (newPayload !== null && newPayload !== undefined) // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
    return {
        ...oldPayload,
        ...newPayload
    };
    return oldPayload;
};
const $ac2928cb7824ba77$var$returnActualValue = (value)=>Array.isArray(value) ? value[0] : value;
// @ts-expect-error - TS7023 - 'mergeFormat' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions. | TS7006 - Parameter 'format' implicitly has an 'any' type.
const $ac2928cb7824ba77$var$mergeFormat = (format, finalKey, finalValue)=>{
    // Ideally format can be object or string
    // Format will only contain 1 object having single key/value where value can be null or an object
    // go inside and wherever we find first null, replace the same with the value.
    // some of the mutation use fieldId whereas other uses like priorityId
    // so whichever key has value === ID will replace the same with the proper mutationKey
    if (typeof format === 'string') {
        if (format === 'ID') return finalKey;
        return format;
    }
    // recursively goes inside to find the null and key param and replace with the corresponding values
    // Also checks for array like labels
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(format).reduce((accumulator, currentKey)=>{
        const currentValue = format[currentKey];
        if (Array.isArray(currentValue)) {
            const mappedValue = Array.isArray(finalValue) ? finalValue : [
                finalValue
            ];
            return {
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...accumulator,
                [currentKey]: mappedValue.map((val)=>$ac2928cb7824ba77$var$mergeFormat(currentValue[0], finalKey, val))
            };
        }
        return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...accumulator,
            [currentKey]: currentValue === null ? $ac2928cb7824ba77$var$returnActualValue(finalValue) : $ac2928cb7824ba77$var$mergeFormat(format[currentKey], finalKey, finalValue)
        };
    }, {});
};
const $ac2928cb7824ba77$export$300f392f5922240 = (otherFields)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const defaultValues = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldIds = [];
    Object.keys(otherFields).forEach((mutationKey)=>{
        const mutationValue = otherFields[mutationKey];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
        if ((0, $cOaQi.FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const mutationGroup = (0, $cOaQi.FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly singleLineTextFields: { readonly value: { readonly fieldId: "ID"; readonly text: null; }; readonly type: "array"; }; readonly epicLinkField: { readonly value: { readonly fieldId: "ID"; readonly epicLink: { readonly issueKey: null; }; }; readonly type: "object"; }; ... 7 more ...; readonly components: { .....'.
            const { type: type = null, value: depth = null } = (0, $cOaQi.FORMATTER)[mutationGroup];
            let pattern = null;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(mutationValue) && depth && type) {
                if (!Array.isArray(mutationValue) && typeof mutationValue === 'object') {
                    const { fieldId: fieldId, fieldValue: fieldValue } = mutationValue;
                    // If fieldValue is different from the key like custom fields
                    pattern = $ac2928cb7824ba77$var$mergeFormat(depth, fieldId || mutationKey, fieldValue);
                    fieldIds.push(fieldId || mutationKey);
                } else {
                    // same as key like summary etc.
                    pattern = $ac2928cb7824ba77$var$mergeFormat(depth, mutationKey, mutationValue);
                    fieldIds.push(mutationKey);
                }
            }
            // merge mutations based on type as some mutations are object whereas others are arrays
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(pattern)) {
                if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(pattern);
                else if (type === 'object') defaultValues[mutationGroup] = pattern;
            }
        }
    });
    return {
        defaultValues: defaultValues,
        fieldIds: fieldIds
    };
};
const $ac2928cb7824ba77$export$1e69307ca1d0a0a = (trigger)=>{
    const anchor = trigger.nodeName === 'A' ? trigger : trigger.querySelector('a');
    if (anchor) {
        const href = anchor.getAttribute('href');
        // @ts-expect-error - TS2769 - No overload matches this call. | TS7006 - Parameter 'qs' implicitly has an 'any' type.
        const { query: query } = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(href, (qs)=>new URLSearchParams(qs));
        const returnData = {
            prefilledFields: {}
        };
        // If data attributes exist, we will prefer those over the query params.
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const pid = anchor.getAttribute('data-pid') || query.get('pid');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const issuetype = anchor.getAttribute('data-issue-type') || query.get('issuetype');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const requestype = anchor.getAttribute('data-itsm-category') || query.get('itsmCategory');
        if (pid) // @ts-expect-error - TS2339 - Property 'pid' does not exist on type '{}'.
        returnData.prefilledFields.pid = pid;
        if (issuetype) // @ts-expect-error - TS2339 - Property 'issuetype' does not exist on type '{}'.
        returnData.prefilledFields.issuetype = issuetype;
        if (requestype) // @ts-expect-error - TS2339 - Property 'requestype' does not exist on type '{}'.
        returnData.prefilledFields.requestype = requestype;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(returnData.prefilledFields)) // @ts-expect-error - TS2322 - Type '{ prefilledFields: {}; }' is not assignable to type 'OldGICPayload'.
        return returnData;
        return {};
    }
    return {};
};
const $ac2928cb7824ba77$export$70cb7a42e309786 = (payload = {})=>{
    const { prefilledFields: gicPreFilledFields, target: target = null } = payload;
    let prefilledFields = gicPreFilledFields;
    if (target) {
        const newPayload = $ac2928cb7824ba77$export$1e69307ca1d0a0a(target);
        prefilledFields = $ac2928cb7824ba77$var$mergePrefilled(gicPreFilledFields, newPayload.prefilledFields);
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(prefilledFields)) {
        const { fieldsToRetain: fieldsToRetain = [], pid: pid, issuetype: issuetype, requestype: requestype, additionalContext: additionalContext, statusId: statusId, ...otherFields } = prefilledFields;
        const outputPayload = {};
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(pid) && pid !== 'undefined') outputPayload.project = {
            projectId: $ac2928cb7824ba77$var$returnActualValue(pid)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issuetype)) outputPayload.issueType = {
            issueTypeId: $ac2928cb7824ba77$var$returnActualValue(issuetype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(requestype)) outputPayload.requestType = {
            key: $ac2928cb7824ba77$var$returnActualValue(requestype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(otherFields.parentId)) outputPayload.parentId = {
            parentId: $ac2928cb7824ba77$var$returnActualValue(otherFields.parentId)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(statusId)) outputPayload.status = {
            statusId: statusId
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(additionalContext)) outputPayload.additionalContext = additionalContext;
        // for other fields
        if (Object.keys(otherFields).length > 0) {
            const { parentId: parentId, ...otherFieldsWithoutParent } = otherFields;
            const { defaultValues: defaultValues, fieldIds: fieldIds } = $ac2928cb7824ba77$export$300f392f5922240((0, $1ybV0.ff)('parent-field-in-gic_d3b3n') && parentId !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(parentId) ? {
                parent: parentId,
                ...otherFieldsWithoutParent
            } : otherFieldsWithoutParent);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(defaultValues)) outputPayload.defaultValues = defaultValues;
            outputPayload.customFieldsToPreserveOnFormRecreation = [
                ...fieldsToRetain,
                ...fieldIds
            ];
        }
        return outputPayload;
    }
    return null;
};
const $ac2928cb7824ba77$export$db3a4d24608ba186 = $ac2928cb7824ba77$export$70cb7a42e309786;

});
parcelRegister("cOaQi", function(module, exports) {

$parcel$export(module.exports, "FORMATTER", () => $5043ffa756a0131b$export$92cfe806f4f0ae2f);
$parcel$export(module.exports, "FIELD_MAPPER_MUTATION_GROUP", () => $5043ffa756a0131b$export$6669905e89f27d17);
const $5043ffa756a0131b$export$92cfe806f4f0ae2f = {
    singleLineTextFields: {
        value: {
            fieldId: 'ID',
            text: null
        },
        type: 'array'
    },
    epicLinkField: {
        value: {
            fieldId: 'ID',
            epicLink: {
                issueKey: null
            }
        },
        type: 'object'
    },
    sprintsField: {
        value: {
            fieldId: 'ID',
            sprints: [
                {
                    sprintId: null
                }
            ]
        },
        type: 'object'
    },
    priority: {
        value: {
            priorityId: 'ID'
        },
        type: 'object'
    },
    datePickerFields: {
        value: {
            fieldId: 'ID',
            date: {
                formattedDate: null
            }
        },
        type: 'array'
    },
    dateTimePickerFields: {
        value: {
            fieldId: 'ID',
            dateTime: {
                formattedDateTime: null
            }
        },
        type: 'array'
    },
    labelsFields: {
        value: {
            fieldId: 'ID',
            labels: [
                {
                    name: null
                }
            ]
        },
        type: 'array'
    },
    singleSelectUserPickerFields: {
        value: {
            fieldId: 'ID',
            user: {
                accountId: null
            }
        },
        type: 'array'
    },
    multipleVersionPickerFields: {
        value: {
            fieldId: 'ID',
            versions: [
                {
                    versionId: null
                }
            ]
        },
        type: 'array'
    },
    components: {
        value: {
            componentId: null
        },
        type: 'array'
    },
    parentField: {
        value: {
            issueId: null
        },
        type: 'object'
    }
};
const $5043ffa756a0131b$export$6669905e89f27d17 = {
    summary: 'singleLineTextFields',
    epic: 'epicLinkField',
    epicName: 'singleLineTextFields',
    duedate: 'datePickerFields',
    startdate: 'datePickerFields',
    plannedStartDate: 'dateTimePickerFields',
    plannedEndDate: 'dateTimePickerFields',
    labels: 'labelsFields',
    sprint: 'sprintsField',
    assignee: 'singleSelectUserPickerFields',
    reporter: 'singleSelectUserPickerFields',
    fixVersions: 'multipleVersionPickerFields',
    components: 'components',
    parent: 'parentField'
};

});




//# sourceMappingURL=async-new-issue-create-trigger.ac4e6232.js.map
